import React from "react";
import { Button, Form } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLoaderData } from "react-router-dom";

import PaymentReminderTabs from "@SiteManagement/PaymentReminders/components/PaymentReminderTabs";
import useFormHandlers from "@SiteManagement/PaymentReminders/hooks/useFormHandlers";
import getReminderInterval from "@SiteManagement/PaymentReminders/lib/getReminderInterval";
import {
    PaymentReminder,
    PaymentRemindersForm,
} from "@SiteManagement/PaymentReminders/types/paymentreminders";

const PaymentReminders = (): React.JSX.Element => {
    const { paymentReminders } = useLoaderData() as {
        paymentReminders: Array<PaymentReminder>;
    };

    const defaultValues = paymentReminders.reduce<
        Partial<PaymentRemindersForm>
    >((acc, reminder) => {
        acc[getReminderInterval(reminder.template_key)] = reminder.content;
        return acc;
    }, {});

    const methods = useForm<PaymentRemindersForm>({
        mode: "onChange",
        defaultValues,
    });

    const { onSubmit } = useFormHandlers({ methods });

    if (paymentReminders.length === 0) {
        return (
            <section className="siteSettingsContent">
                <p>No payment reminder templates were returned by the API.</p>
            </section>
        );
    }

    return (
        <section className="siteSettingsContent">
            <FormProvider {...methods}>
                <Form onSubmit={methods.handleSubmit(onSubmit)}>
                    <PaymentReminderTabs paymentReminders={paymentReminders} />
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={!methods.formState.isDirty}
                    >
                        Update Reminders
                    </Button>
                </Form>
            </FormProvider>
        </section>
    );
};

export default PaymentReminders;
